// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  height: 350px;
  min-height: 350px;
  overflow-y: scroll;
  overflow-x: hidden;
}
.c1 {
  padding-bottom: 10px;
  font-size: 12pt !important;
  font-style: normal !important;
}
.header-text {
  font-size: 19px !important;
  padding: 10px !important;
  margin-bottom: 10px !important;
  text-align: center;
  color: #000 !important;
}
.group-applicants {
  width: 800px;
  max-width: 800px;
}
.r1 {
  padding-bottom: 8px;
}
.grid.g {
  grid-template-columns: repeat(5, auto);
  padding-top: 0 !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared-components-module/group-applicant/group-applicant.component.less"],"names":[],"mappings":"AAGA;EACI,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AAFJ;AAKA;EACE,oBAAA;EACA,0BAAA;EACA,6BAAA;AAHF;AAMA;EACE,0BAAA;EACA,wBAAA;EACA,8BAAA;EACA,kBAAA;EACA,sBAAA;AAJF;AAOA;EACE,YAAA;EACA,gBAAA;AALF;AAQA;EACE,mBAAA;AANF;AASA;EACE,sCAAA;EACA,yBAAA;AAPF","sourcesContent":["@import (reference) url('../../../styles.less');\n@import (reference) url('../../../assets/ngb-modals.less');\n\n.wrapper {\n    height: 350px;\n    min-height: 350px;\n    overflow-y: scroll;\n    overflow-x: hidden;\n}\n\n.c1 {\n  padding-bottom: 10px;\n  font-size: 12pt !important;\n  font-style: normal !important;\n}\n\n.header-text {\n  font-size: 19px !important; \n  padding: 10px !important;\n  margin-bottom: 10px !important;\n  text-align: center;\n  color: #000 !important;\n}\n\n.group-applicants {\n  width: 800px;\n  max-width: 800px;\n}\n\n.r1 {\n  padding-bottom: 8px;\n}\n\n.grid.g {\n  grid-template-columns: repeat(5, auto);\n  padding-top: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
